import * as React from 'react';
import { Button, Grid, Responsive, Loader, Dimmer } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { getI18n } from 'services/i18n-service';
import { UserGrid } from 'components/user-grid';
import { GridLayoutType } from 'components/user-grid/state';
import { hasPermissionTo } from 'helpers/permission-helper';
import { Mode } from 'types/mode';
import { Permission } from 'types/permission';
import { translations } from 'types/translations';

import './styles.css';
import { Scrollable } from 'components/scrollable/component';

export interface UsersGridProps {
  isLoading: boolean;
  permissions: string;
}

export interface UsersGridActionProps {
  getTenant: () => void;
  listUsers: () => void;
}

export type Props = UsersGridProps & UsersGridActionProps;

export class UsersPage extends React.Component<Props> {

  componentWillMount() {
    this.props.getTenant();
    this.props.listUsers();
  }

  public render() {
    const i18n = getI18n();

    const canCreateUser: boolean = hasPermissionTo([Mode.Create], Permission.Users, this.props.permissions);

    return (
      <Scrollable>
        <Dimmer.Dimmable>
          <Grid className="padded-top-grid users-grid">
            <Dimmer active={this.props.isLoading}>
              <Loader />
            </Dimmer>
            <Grid.Row>
              <Grid.Column>
                <Responsive {...Responsive.onlyMobile} as={React.Fragment}>
                  <br />
                  <br />
                  <UserGrid gridLayout={GridLayoutType.usersMobile} rowId="id" rowHeight={75} />
                </Responsive>
                <Responsive minWidth={Responsive.onlyTablet.minWidth} as={React.Fragment}>
                  <br />
                  <br />
                  <UserGrid gridLayout={GridLayoutType.usersComputer} rowId="id" />
                </Responsive>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {
            canCreateUser &&
            <>
              <Responsive {...Responsive.onlyMobile} as={React.Fragment}>
                <Button
                  icon="add"
                  className="add-user-button neutral-dark"
                  as={Link}
                  to={`${process.env.PUBLIC_URL}/user/create`}
                  content={i18n.t(translations.AddUser)}
                />
              </Responsive>
              <Responsive minWidth={Responsive.onlyTablet.minWidth} as={React.Fragment}>
                <Button
                  icon="add"
                  labelPosition="right"
                  className="add-user-button neutral-dark"
                  as={Link}
                  to={`${process.env.PUBLIC_URL}/user/create`}
                  content={i18n.t(translations.AddUser)}
                />
              </Responsive>
            </>
          }
        </Dimmer.Dimmable>
      </Scrollable>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/users/component.tsx